import React, { useEffect, useState } from "react";
import { Avatar, Button, Col, Modal, Typography, DatePicker, Row } from "antd";
import "./ChooseVehicleModal.css";
import { ReactComponent as QwikLogo } from "../../../../../assets/icons/Qwik-logo.svg";

import { ReactComponent as QwikNote } from "../../../../../assets/icons/qwiknote.svg";
import { ReactComponent as IconClock } from "../../../../../assets/icons/icon-clock-1.svg";
import { ReactComponent as Bikeinfo } from "../../../../../assets/icons/bikeinfo.svg";
import CustomDropdown from "../AddPaymentModal/CustomDropdown";
import AddVehicleCustomDropdown from "../AddPaymentModal/AddVehicleCustomDropdown";
import ChooseAddressModal from "./ChooseAddressModal/ChooseAddressModal";
import { TimeDropdownData } from "../../../../ManageOrders/OrderDetails/OrderConstant/Constant";
import { baseUrl } from "../../../../../commonUtils/commonUtils";
import dayjs from "dayjs";
const { Text } = Typography;

const logisticsChannelOptions = [
  {
    value: "DEFAULT",
    label: "Select your logistics channel",
    disabled: true,
  },
  {
    value: "MOB_VEHICLE_LT_3H",
    label: "MOB vehicle - pickup LESS than 3hrs",
    delayInMinutes: 75,
    vehicleMode: "mob",
  },
  {
    value: "MOB_VEHICLE_GT_3H",
    label: "MOB vehicle - pickup MORE than 3hrs",
    delayInMinutes: 195,
    vehicleMode: "mob",
  },
  {
    value: "YOUR_VEHICLE_LT_3H",
    label: "Partner vehicle - pickup LESS than 3hrs",
    delayInMinutes: 75,
    vehicleMode: "partner",
  },
  {
    value: "YOUR_VEHICLE_GT_3H",
    label: "Partner vehicle - pickup MORE than 3hrs",
    delayInMinutes: 195,
    vehicleMode: "partner",
  },
];
const pickupScheduleChoices = [
  // { key: "5s", value: "5 seconds later", minutes: 5 / 60 },
  // { key: "1m", value: "1 min later", minutes: 1 },
  { key: "15m", value: "15 mins later", minutes: 15 },
  { key: "30m", value: "30 mins later", minutes: 30 },
  { key: "45m", value: "45 mins later", minutes: 45 },
  { key: "1h", value: "1 hour later", minutes: 60 },
  { key: "1h15m", value: "1 hour 15 mins later", minutes: 75 },
  { key: "1h30m", value: "1 hour 30 mins later", minutes: 90 },
  { key: "1h45m", value: "1 hour 45 mins later", minutes: 105 },
  { key: "2h", value: "2 hours later", minutes: 120 },
  { key: "3h", value: "3 hours later", minutes: 180 },
  // { key: "3h30m", value: "3 hours 30 mins later", minutes: 210 },
  // { key: "4h", value: "4 hours later", minutes: 240 },
];

const ChooseVehicleModal = ({
  isModalOpen,
  setIsModalOpen,
  handleOk,
  vendorAddressData,
  pickupAddressValue,
  setPickupAddressValue,
  vendorAddressapiSuccess,
  updateOrderStatusLoading,
  DeliveryDateValue,
  SelectedTime,
  setDeliveryDateValue,
  setSelectedTime,
  orderType,
  vehicleDetailData,
}) => {
  const isQuickOrder = orderType === "QUICK_ORDER";
  const [logisticsChannelVisible, setLogisticsChannelVisible] = useState(false);
  const [pickupTimeVisible, setPickupTimeVisible] = useState(false);
  const [vehicleVisible, setVehicleVisible] = useState(false);
  const [selectedLogisticsChannel, setSelectedLogisticsChannel] = useState("");
  const [pickupTimeSelected, setPickupTimeSelected] = useState("");
  const [vehicleTypeSelected, setVehicleTypeSelected] = useState("SELECT VEHICLE");
  const [selectedVehicleData, setSelectedVehicleData] = useState({});
  const [pickupAddressModal, setPickupAddressModal] = useState(false);
  const [value, setValue] = useState();
  const [date, setDate] = useState("");

  const availableLogisticsChannels = isQuickOrder
    ? logisticsChannelOptions.filter((item) =>
        ["DEFAULT", "MOB_VEHICLE_LT_3H", "YOUR_VEHICLE_LT_3H"].includes(item.value)
      )
    : logisticsChannelOptions;
  const logisticsChannelDropdownOptions = availableLogisticsChannels
    .filter((item) => item.value !== "DEFAULT")
    .map((item) => ({
      key: item.value,
      value: item.label,
      disabled: item.disabled,
    }));

  const selectedLogisticsConfig = availableLogisticsChannels.find(
    (item) => item.value === selectedLogisticsChannel
  );
  const requiresMobVehicle = selectedLogisticsConfig?.vehicleMode === "mob";
  const selectedPickupSchedule = pickupScheduleChoices.find(
    (item) => item.value === pickupTimeSelected
  );
  const pickupTimeOptions = [
    {
      key: "select_pickup_time",
      value: "Select your pickup time",
    },
    ...pickupScheduleChoices.map((item) => ({
      key: item.key,
      value: item.value,
    })),
  ];
  const pickupAtText = pickupTimeSelected
    ? dayjs().add(selectedPickupSchedule?.minutes || 0, "minute").format("hh:mm A")
    : "--:--";
  const buildAssignVehiclePayload = () => {
    const scheduleDateTime = dayjs()
      .add(selectedPickupSchedule?.minutes || 0, "minute")
      .format("YYYY-MM-DDTHH:mm:ssZ");
    return {
      logistic_channel: selectedLogisticsChannel,
      pickup_address_id: pickupAddressValue?.id || pickupAddressValue?.address_id,
      schedule_option: selectedPickupSchedule?.key,
      schedule_date_time: scheduleDateTime,
      confirm_delivery_address: true,
      vehicles: requiresMobVehicle
        ? [
            {
              vehicle: selectedVehicleData?.id,
              count: 1,
              vechicle_number: "",
            },
          ]
        : [],
    };
  };

  const onChange = (date, dateString) => {
    const currentDate = dayjs(date).format("YYYY-MM-DD");
    setDeliveryDateValue(date);
    setDate(currentDate);
  };

  const logisticsChannelTypeVisible = (flag) => {
    setLogisticsChannelVisible(flag);
  };
  const pickupTypeVisible = (flag) => {
    setPickupTimeVisible(flag);
  };
  const vehicleTypeVisible = (flag) => {
    setVehicleVisible(flag);
  };

  const handleCancel = () => {
    setValue();
    setIsModalOpen(false);
    setPickupAddressValue({});
  };
  const handLogisticsClick = (selectedValue) => {
    const selectedOption = availableLogisticsChannels.find(
      (item) => item.label === selectedValue
    );
    if (!selectedOption || selectedOption.value === "DEFAULT") {
      setSelectedLogisticsChannel("");
      setPickupTimeSelected("");
      setLogisticsChannelVisible(false);
      return;
    }
    setSelectedLogisticsChannel(selectedOption.value);
    setLogisticsChannelVisible(false);
    setPickupTimeSelected("");
  };

  const handTimeClick = (selectedValue) => {
    setSelectedTime(selectedValue);
  };
  const handlePickupTimeClick = (selectedValue) => {
    if (selectedValue === "Select your pickup time") {
      setPickupTimeSelected("");
      setPickupTimeVisible(false);
      return;
    }
    setPickupTimeSelected(selectedValue);
    setPickupTimeVisible(false);
  };
  const handleVehicleClick = (selectedValue) => {
    const selectedVehicle = vehicleDetailData?.find((option) => {
      return option.vechicle_type === selectedValue;
    });
    setVehicleTypeSelected(selectedValue);
    setVehicleVisible(false);
    setSelectedVehicleData(selectedVehicle || {});
  };

  const handleAddressChange = () => {
    setPickupAddressModal(true);
  };

  useEffect(() => {
    if (vendorAddressData?.data) {
      setPickupAddressValue(vendorAddressData?.data[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendorAddressData, vendorAddressapiSuccess]);

  useEffect(() => {
    if (!isModalOpen) {
      return;
    }
    setSelectedLogisticsChannel("");
    setPickupTimeSelected("");
    setVehicleTypeSelected("SELECT VEHICLE");
    setSelectedVehicleData({});
  }, [isModalOpen, orderType, vehicleDetailData]); // eslint-disable-line react-hooks/exhaustive-deps

  const disableSubmit =
    !selectedLogisticsConfig ||
    !pickupTimeSelected ||
    !pickupAddressValue?.id ||
    (requiresMobVehicle && !selectedVehicleData?.id);

  return (
    <>
      <Modal
        
        title="Assign vehicle for shipment"
        open={isModalOpen}
        className="vehiclemodal"
        onOk={handleCancel}
        onCancel={handleCancel}
        footer={
          <Col className="addFile-wrapper">
            <Button
              key="back"
              className="vehicle-cancel-btn"
              onClick={handleCancel}
            >
              CANCEL
            </Button>
            <Button
              key="submit"
              type="primary"
              className="vehicle-submit-btn"
              onClick={() => handleOk(buildAssignVehiclePayload())}
              disabled={disableSubmit}
              loading={updateOrderStatusLoading}
            >
              ASSIGN AND ACCEPT ORDER
            </Button>
          </Col>
        }
      >
        <Col style={{height:"500px", overflowY:"scroll"}}>
          {isQuickOrder && (
            <Col className="choose-vehicle-quick-strip">
              <QwikLogo className="choose-vehicle-quick-logo" />
              <Text className="choose-vehicle-quick-text">1-4 HRS DELIVERY</Text>
            </Col>
          )}
          <Col className="choose-vehicle-logistics">
            <Text className="logistics-partner-txt">
              Select your logistics channel <span style={{ color: "#bf2600" }}>*</span>
            </Text>
            <Col className="dropdown-wrapper choose-vehicle-full-width">
              <CustomDropdown
                handleOptionClick={handLogisticsClick}
                visible={logisticsChannelVisible}
                handleVisibleChange={logisticsChannelTypeVisible}
                selectedText={
                  selectedLogisticsConfig?.label || "Select your logistics channel"
                }
                options={logisticsChannelDropdownOptions}
              />
            </Col>
          </Col>
          <Col className="pickup-address-wrapper">
            {vendorAddressData?.data && (
              <Col className="choose-vehicle-address">
                <Text className="choose-vehicle-header">Confirm your pickup address</Text>
                {vendorAddressData?.data?.length ? (
                  <>
                    {" "}
                    <Text style={{ fontSize: "1rem" }}>
                      {pickupAddressValue?.name ||
                        vendorAddressData?.data[0]?.name ||
                        ""}
                    </Text>
                    <Col>
                      <Text style={{ fontSize: "1rem" }}>
                        {pickupAddressValue?.address ||
                          vendorAddressData?.data[0]?.address ||
                          ""}
                      </Text>{" "}
                      ,
                      <Text style={{ fontSize: "1rem" }}>
                        {pickupAddressValue?.address_line_2 ||
                          vendorAddressData?.data[0]?.address_line_2 ||
                          ""}
                      </Text>
                    </Col>
                    <Col>
                      <Text style={{ fontSize: "1rem" }}>
                        {pickupAddressValue?.city ||
                          vendorAddressData?.data[0]?.city ||
                          ""}
                      </Text>{" "}
                      ,
                      <Text style={{ fontSize: "1rem" }}>
                        {pickupAddressValue?.state ||
                          vendorAddressData?.data[0]?.state ||
                          ""}
                      </Text>{" "}
                      ,
                      <Text style={{ fontSize: "1rem" }}>
                        {pickupAddressValue?.pincode ||
                          vendorAddressData?.data[0]?.pincode ||
                          ""}
                      </Text>
                    </Col>
                    <Text style={{ fontSize: "1rem" }}>
                      {pickupAddressValue?.phone_number ||
                        vendorAddressData?.data[0]?.phone_number ||
                        ""}
                    </Text>
                  </>
                ) : (
                  "No Address Found"
                )}
              </Col>
            )}
            {vendorAddressData?.data?.length > 0 && (
              <Text
                className="choose-vehicle-change"
                onClick={handleAddressChange}
              >
                Change
              </Text>
            )}
          </Col>
          {!isQuickOrder && (
            <Col className="choose-vehicle-logistics">
              <Text className="logistics-partner-txt">
                Delivery date and time <span style={{ color: "#bf2600" }}>*</span>
              </Text>
              <Row>
                <Col
                  className="dropdown-wrapper1"
                  style={{ width: "40%", marginRight: "10px" }}
                >
                  <DatePicker
                    format={"DD-MMM-YYYY"}
                    style={{
                      height: "46px",
                      width: "100%",
                      borderRadius: "8px",
                      border: "solid 1px #bac7d5",
                      borderColor: date ? "#0a243f" : "#dedede",
                    }}
                    value={DeliveryDateValue}
                    onChange={onChange}
                  />
                </Col>
                <Col className="dropdown-wrapper" style={{ width: "57%" }}>
                  <CustomDropdown
                    options={TimeDropdownData}
                    handleOptionClick={handTimeClick}
                    selectedText={SelectedTime}
                    className={"DeliverySlotClass"}
                  />
                </Col>
              </Row>
            </Col>
          )}
          <Col className="choose-vehicle-logistics">
            <Text className="logistics-partner-txt">
              Pickup time <span style={{ color: "#bf2600" }}>*</span>
            </Text>
            <Row className="pickup-time-row">
              <Col className="dropdown-wrapper pickup-time-left">
                <CustomDropdown
                  handleOptionClick={handlePickupTimeClick}
                  visible={pickupTimeVisible}
                  handleVisibleChange={pickupTypeVisible}
                  selectedText={pickupTimeSelected || "Select your pickup time"}
                  options={pickupTimeOptions}
                  className="pickup-time-dropdown-scroll"
                />
              </Col>
              <Col className="pickup-time-right">
              <IconClock/>
                <Text className="pickup-time-at">{`at ${pickupAtText}`}</Text>
              </Col>
            </Row>
          </Col>
          {requiresMobVehicle ? (
            <Col className="choose-vehicle-logistics choose-vehicle-note">
              <Text className="logistics-partner-txt">
                Select vehicle <span style={{ color: "#bf2600" }}>*</span>
              </Text>
              <Col className="dropdown-wrapper choose-vehicle-half-width">
                <AddVehicleCustomDropdown
                  handleOptionClick={handleVehicleClick}
                  visible={vehicleVisible}
                  handleVisibleChange={vehicleTypeVisible}
                  selectedText={vehicleTypeSelected}
                  options={vehicleDetailData}
                />
              </Col>
              {selectedVehicleData?.vechicle_type && (
                <Col className="choose-vehicle-card ">
                  <Avatar
                    shape="square"
                    src={`${baseUrl}${selectedVehicleData?.vechicle_image}`}
                    size={48}
                  />
                  <Col className="choose-vehicle-card-detail">
                    <Col className="choose-vehicle-meta-row">
                      <Text className="choose-vehicle-meta-key">
                        Maximum shipment weight:
                      </Text>
                      <Text className="choose-vehicle-meta-value">
                        {selectedVehicleData?.vechicle_type}
                      </Text>
                    </Col>
                    <Col className="choose-vehicle-meta-row">
                      <Text className="choose-vehicle-meta-key">
                        Vehicle storage (LxBxH):
                      </Text>
                      <Text className="choose-vehicle-meta-value">
                        {`${selectedVehicleData?.vechicle_storage} cm`}
                      </Text>
                    </Col>
                  </Col>
                </Col>
              )}
              <Text className="choose-vehicle-support-text">
                Only one vehicle can be booked per order. Choose a vehicle that fits
                your complete order. For additional vehicles, please reach out to customer
                support.
              </Text>
            </Col>
          ) : (
            <Col className="choose-vehicle-partner-note">
              <Bikeinfo />
              <Text className="choose-vehicle-partner-text">
                Please check with partner to assign vehicle
              </Text>
            </Col>
          )}
          <Col className="choose-vehicle-guidance">
            <QwikNote className="choose-vehicle-guidance-icon" />
            <Text className="choose-vehicle-guidance-text">
              Please share only the MOB Delivery Challan and Invoice with the driver at
              the time of dispatch.
            </Text>
          </Col>
        </Col>
        <ChooseAddressModal
          setPickupAddressValue={setPickupAddressValue}
          isModalOpen={pickupAddressModal}
          setIsModalOpen={setPickupAddressModal}
          vendorAddressData={vendorAddressData}
          value={value}
          setValue={setValue}
        />
      </Modal>
    </>
  );
};
export default ChooseVehicleModal;
